import FormJaivana from "dashboard_jaivana_v1";
/**
 * @description: CustomRecuperarContraseña
 * @author: Juan Camilo Villa
 * @version: jdesk_1.01.0009.1
 **/


class CustomCambiarContrasena extends FormJaivana.form {
  constructor(props) {
    super(props);
    this.initForm = this.initForm.bind(this);
    this.verificarUsuario = this.verificarUsuario.bind(this);
    this.successverificarUsuario = this.successverificarUsuario.bind(this);
    this.mostrarMensajeEnvioExitoso = this.mostrarMensajeEnvioExitoso.bind(this);
    this.enviarCodigoEmail = this.enviarCodigoEmail.bind(this);
    this.successEnviarCodigoEmail = this.successEnviarCodigoEmail.bind(this);
    this.enviarCodigoCelular = this.enviarCodigoCelular.bind(this);
    this.successEnviarCodigoCelular = this.successEnviarCodigoCelular.bind(this);
    this.enviarNuevaContraseña = this.enviarNuevaContraseña.bind(this);
    this.successEnviarNuevaContraseña = this.successEnviarNuevaContraseña.bind(this);
    this.codigo_recibido = ''

    /**
     Aqui falta organizar los campos de las contraseñas. Como el formulario 
    se va a cambiar. por ahora se suben cambios faltando la parte mensionada
     */
    

  }

  initForm() {
    console.log("Formulario CustomRecuperarContrasena,  @version: jdesk_1.01.0009.1, @author: Juan Camilo Villa");


      this.getField('enviar_codigo_email').setDisabled(true); 
      this.getField('enviar_codigo_celular').setDisabled(true); 
      this.getField('codigo_recibido').setDisabled(true); 
      this.getField('numero_celular').setDisabled(true);
      this.getField('nueva_clave').setDisabled(true);
      this.getField('verificar_clave').setDisabled(true);
      this.getField('sugerir').setDisabled(true);  
      this.getField('enviar').setDisabled(true);  
      
      this.getField('aceptar').setClick(() =>{
         this.verificarUsuario();
      });

      this.getField('enviar_codigo_email').setClick(()=>{       
          this.enviarCodigoEmail();
      });

      this.getField('enviar_codigo_celular').setClick(()=>{       
          this.enviarCodigoCelular();
      });
      this.getField('enviar').setClick(()=>{       
          this.enviarNuevaContraseña();
      });

/*       this.getField('nueva_clave').setOnChange((props) => {         
        if (this.getField('nueva_clave').getValue() === '' || this.getField('nueva_clave').getValue() === ' ') {
            
        } else {
            this.getField('nueva_clave').setTypePassword(true);
        }
      });

      this.getField('verificar_clave').setOnChange((props) => { 
        if (this.getField('verificar_clave').getValue() === '' || this.getField('verificar_clave').getValue() === ' ') {
          
        } else {
            if(this.getField('verificar_clave').valid()){
              this.getField('verificar_clave').setError(false,'')
            }
            this.getField('verificar_clave').setTypePassword(true);            
        }
      }); */
        
  }


  verificarUsuario(){
    if (this.getField('usuario').valid() && this.getField('email').valid() ) {
        let datos={ datos: {
            usuario : this.getField('usuario').getValue(),
            email : this.getField('email').getValue(),
            numero_celular : this.getField('numero_celular').getValue(),
           }};
           
           this.generalFormatPmv = { tipo_servicio: 'heus-recuperarpass', operacion: 'verificarUsuario', operacion_tipo: 'consulta' };
           this.service.send(
               {
                   endpoint: this.constant.formConfiguration(),
                   method:'GET',
                   body: datos,
                   success: this.successverificarUsuario,
                   error: this.error_,
                   general: this.generalFormatPmv,
                   showMessage: false
                   
               });
        
    }

  }

    successverificarUsuario(data){
        if(data.estado_p === 200){
            this.getField('email').setDisabled(true); 
            this.getField('usuario').setDisabled(true);
            this.getField('usuario_id').setValue(data.data[0].id)
            this.getField('aceptar').setDisabled(true); 
            this.getField('numero_celular').setDisabled(false);
            this.getField('enviar_codigo_email').setDisabled(false);
            this.getField('enviar_codigo_celular').setDisabled(false);
            this.codigo_recibido = data.data[0].codigo_recibido;
        }else if(data.estado_p === 502){
            this.alertGeneral.toggle(true, data.data.errores , 'error');
            
        }else{
            this.alertGeneral.toggle(true, data.data.errores , 'error');
            
        }
    }
    
    enviarCodigoEmail(){
        if (this.getField('usuario_id').valid() && this.getField('email').valid() ) {                
                let datos={ datos: {
                    id_user : parseInt(this.getField('usuario_id').getValue()),
                    email: this.getField('email').getValue(),
                    codigo_verificacion: this.codigo_recibido,
                }};
                
                this.generalFormatPmv = { tipo_servicio: 'heus-recuperarpass', operacion: 'enviarCodigoEmail', operacion_tipo: 'consulta' };
                this.service.send(
                    {
                        endpoint: this.constant.formConfiguration(),
                        method:'GET',
                        body: datos,
                        success: this.successEnviarCodigoEmail,
                        error: this.error_,
                        general: this.generalFormatPmv,
                        showMessage: false
                        
                    });
                
            }else{
                this.alertGeneral.toggle(true, 'Datos de usuario no válidos' , 'error');
            }

    }
        
    successEnviarCodigoEmail(data){
        if (data.estado_p === 200) {
            /* this.mostrarMensajeEnvioExitoso(data.data.mensaje); */
            this.mostrarMensajeEnvioExitoso('Se envió el código de verificación a su correo');
            this.getField('codigo_recibido').setValue('');  
            this.getField('codigo_recibido').setDisabled(false);
            this.getField('nueva_clave').setDisabled(false);
            this.getField('verificar_clave').setDisabled(false);  
            this.getField('enviar').setDisabled(false); 
            this.getField('sugerir').setDisabled(false); 
        
        }else{
            this.alertGeneral.toggle(true, data.data.errores , 'error');
        }
    }
    enviarCodigoCelular(){
        if (this.getField('usuario_id').valid() && this.getField('numero_celular').valid()) {                
                let datos={ datos: {
                    codigo_verificacion: this.codigo_recibido,
                    numero_celular: this.getField('numero_celular').getValue(),
                }};
                
                this.generalFormatPmv = { tipo_servicio: 'heus-recuperarpass', operacion: 'enviarCodigoCelular', operacion_tipo: 'consulta' };
                this.service.send(
                    {
                        endpoint: this.constant.formConfiguration(),
                        method:'GET',
                        body: datos,
                        success: this.successEnviarCodigoCelular,
                        error: this.error_,
                        general: this.generalFormatPmv,
                        showMessage: false
                        
                    });
                
            }else{
                this.alertGeneral.toggle(true, 'Datos de usuario no válidos' , 'error');
            }

    }
        
    successEnviarCodigoCelular(data){
        if (data.estado_p === 200) {
            /* this.mostrarMensajeEnvioExitoso(data.data.mensaje); */
            this.mostrarMensajeEnvioExitoso('Se envió el código de verificación a su celular');
            this.getField('codigo_recibido').setValue('');  
            this.getField('codigo_recibido').setDisabled(false);
            this.getField('nueva_clave').setDisabled(false);
            this.getField('verificar_clave').setDisabled(false);
            this.getField('enviar').setDisabled(false);  
            this.getField('sugerir').setDisabled(false);  
        
        }else{
            this.alertGeneral.toggle(true, data.data.errores , 'error');
        }
    }

    enviarNuevaContraseña(){
        if (this.getField('codigo_recibido').getValue() === this.codigo_recibido) {
            
        } else {
            
        }

    }

    successEnviarNuevaContraseña(data){
        if (data.estado_p === 200) {
            this.mostrarMensajeEnvioExitoso('Se ha reestablecido su contraseña');

            this.getField('usuario').setDisabled(false); 
            this.getField('email').setDisabled(false); 
            this.getField('aceptar').setDisabled(false); 
            this.getField('enviar_codigo_email').setDisabled(true); 
            this.getField('enviar_codigo_email').setDisabled(true); 
            this.getField('enviar_codigo_celular').setDisabled(true); 
            this.getField('codigo_recibido').setDisabled(true); 
            this.getField('numero_celular').setDisabled(true);
            this.getField('nueva_clave').setDisabled(true);
            this.getField('verificar_clave').setDisabled(true);
            this.getField('sugerir').setDisabled(true);  
            this.getField('enviar').setDisabled(true); 
            this.codigo_recibido = ''; 
            
        }else{
            this.alertGeneral.toggle(true, data.data.errores , 'error');
        }

    }



    mostrarMensajeEnvioExitoso(mensaje){
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', mensaje );
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("Aceptar"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    successObtenerCodigoVerificacion(data){
        if (data.estado_p === 200) {
            this.mostrarMensajeEnvioExitoso('Se envió el código de verificación a su teléfono');
            this.getField('codigo_recibido').setDisabled(false); 
            this.getField('aceptar').setDisabled(false); 
            this.codigo_recibido = data.data.codigo

            
        }else{
            this.alertGeneral.toggle(true, data.data.errores , 'error');
        }
    }












}



FormJaivana.addController("heus-recuperarpass", CustomCambiarContrasena);
export default CustomCambiarContrasena;